<div>
    <nav class="navbar navbar-light bg-light">
        <a class="navbar-brand" (click)="scrollToTop()">
            <img src="assets/bharat-khata.jpeg" width="100" height="43.6363" class="d-inline-block" alt="">
            <!-- <span class="nav-text">Bharat Khata</span> -->
        </a>
    </nav>
</div>